import React from 'react';
import { Avatar, SxProps } from '@mui/material';
import { CurrencyAttributes, getImage } from '@loyalty/shared-common/gamification-api-client';
import { sxs } from '@qualifio/ui-commons';
import { useTranslation } from 'react-i18next';

interface Props {
  currency?: CurrencyAttributes;
  style?: Record<string, string>;
  className?: string;
  sx?: SxProps;
}

export function CurrencyImage({ currency, sx = {}, style = {}, className = '' }: Props) {
  const { i18n } = useTranslation();
  const currencyImage = getImage(currency, i18n.language);

  return (
    <Avatar
      src={currencyImage}
      alt="currency"
      className={className}
      sx={sxs(
        {
          width: '25px',
          height: '25px',
          filter: currency?.deletedAt ? 'grayscale(100%)' : undefined,
          opacity: currency?.deletedAt ? '0.5' : '1',
        },
        sx,
      )}
      style={style}
    />
  );
}
